import { type TimezonesEnum } from '@webapp/core/entities/external/enums/TimezonesEnum'
import { convertISOStringToTimezone } from '@webapp/core/utils/dates/convertISOStringToTimezone'

export const formatSecondaryCategorySpend = ({
  secondaryCategorySpend,
  startDate,
  endDate,
  headquartersTimezone,
}: {
  secondaryCategorySpend: {
    approved: string
    currentRequestPending: string
    invoiced: string
    pending: string
    purchased: string
    received: string
  }
  startDate: ISODateString
  endDate: ISODateString
  headquartersTimezone: TimezonesEnum
}) => {
  const adjustedStartDate = convertISOStringToTimezone(
    startDate,
    headquartersTimezone
  )
  const adjustedEndDate = convertISOStringToTimezone(
    endDate,
    headquartersTimezone
  )

  const currentRequestSpend = parseFloat(
    secondaryCategorySpend.currentRequestPending
  )
  const approvedSpend = parseFloat(secondaryCategorySpend.approved)
  const invoicedSpend = parseFloat(secondaryCategorySpend.invoiced)
  const pendingSpend = parseFloat(secondaryCategorySpend.pending)
  const purchasedSpend = parseFloat(secondaryCategorySpend.purchased)
  const receivedSpend = parseFloat(secondaryCategorySpend.received)

  const currentSpend = purchasedSpend + approvedSpend + invoicedSpend
  const spendAfterApproval = currentSpend + currentRequestSpend
  const otherPendingRequests = Math.max(pendingSpend - currentRequestSpend, 0)

  const committedSpend =
    approvedSpend + purchasedSpend + invoicedSpend + receivedSpend
  const totalSpendBeforePending = committedSpend + currentRequestSpend
  const totalSpend = totalSpendBeforePending + otherPendingRequests

  return {
    approvedSpend,
    invoicedSpend,
    purchasedSpend,
    currentSpend,
    otherPendingRequests,
    spendAfterApproval,
    currentRequestSpend,
    oldPendingSpend: pendingSpend,
    // remove above with enable_flexible_spend_tracking removal
    committedSpend,
    requestedSpend: currentRequestSpend,
    totalSpendBeforePending,
    pendingSpend: otherPendingRequests,
    totalSpend,
    startDate: adjustedStartDate,
    endDate: adjustedEndDate,
  }
}
